import * as React from "react";
import { forwardRef } from "react";
const SvgPhone = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 44 62", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M22 41a1 1 0 1 1 0 2 1 1 0 0 1 0-2M22 18a1 1 0 0 1 1 1v15.5a1 1 0 1 1-2 0V19a1 1 0 0 1 1-1" }), /* @__PURE__ */ React.createElement("path", { d: "M37 0a7 7 0 0 1 7 7v48a7 7 0 0 1-7 7H7a7 7 0 0 1-7-7V7a7 7 0 0 1 7-7zM7 2a5 5 0 0 0-5 5v48a5 5 0 0 0 5 5h30a5 5 0 0 0 5-5V7a5 5 0 0 0-5-5z", clipRule: "evenodd" }));
const ForwardRef = forwardRef(SvgPhone);
export { ForwardRef as ReactComponent };
